export default "__VITE_ASSET__DmwM_DXN__ 584w";